<template>
  <div class="bk-info-box">
    <Icon name="info" />
    <p v-html="text" />
  </div>
</template>

<script setup>
import { Icon } from "#blokkli/components";
defineProps({
  text: { type: String, required: true }
});
</script>
